import { render } from "./CruResource.vue?vue&type=template&id=04ebe6ac&scoped=true"
import script from "./CruResource.vue?vue&type=script&lang=js"
export * from "./CruResource.vue?vue&type=script&lang=js"

import "./CruResource.vue?vue&type=style&index=0&id=04ebe6ac&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ebe6ac"]])

export default __exports__